module.exports = __webpack_public_path__ + "static/media/Cookies-ExpertMFD.e9dd3d29.pdf";